module.exports = __webpack_public_path__ + "static/media/9.2585faa2.jpg";